import { render, staticRenderFns } from "./FlexText.vue?vue&type=template&id=b28ed460&"
import script from "./FlexText.vue?vue&type=script&lang=js&"
export * from "./FlexText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports